import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "car"
const CarIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.382 8.539C19.539 5.819 17.86 4 15.5 4h-7C6.14 4 4.46 5.82 3.618 8.539a1.75 1.75 0 1 0-.59 3.447C3.01 12.32 3 12.657 3 13v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1h10v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6c0-.343-.01-.681-.028-1.014a1.75 1.75 0 1 0-.59-3.447ZM5.5 11c0-1 0-5 3.5-5h6c3.5 0 3.5 4 3.5 5h-13Zm12 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm-11 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
      />
    </svg>
  )
}
export default CarIcon
